import { FIELD_VALUE_TYPE, OBJECT_VALUE_TYPE } from '@constants'

export const isObjectValueType = (
  value: FIELD_VALUE_TYPE | null | undefined
): value is FIELD_VALUE_TYPE => {
  return value ? OBJECT_VALUE_TYPE.includes(value) : false
}
